// extracted by mini-css-extract-plugin
export default {"formContainer":"User_formContainer__hMWac"};